import moment from 'moment'

// Single source of truth for "does this customer's PCP apply here, and at what percent".
// userPCP is always an array (0 or 1 items, since a customer holds at most one PCP agreement).
// productId is the catalog Product _id being priced, or null for quote-based items that have none
// (a 'selected'-scope agreement can never match those, since it references catalog products).
export function getApplicablePcpDiscountPercent(userPCP, productId) {
  if (!Array.isArray(userPCP) || userPCP.length === 0) return 0
  const pcp = userPCP[0]
  if (!pcp.startAt || !pcp.endAt) return 0
  const now = moment()
  // startAt/endAt come from a date picker (midnight of that calendar day) — treat the
  // agreement as valid through the end of its end date, not expiring at its first instant.
  if (now.isBefore(moment(pcp.startAt).startOf('day')) || now.isAfter(moment(pcp.endAt).endOf('day'))) return 0
  if (pcp.discountOn === 'selected') {
    if (productId == null) return 0
    return (pcp.products || []).some(p => (p._id || p) == productId) ? pcp.discount : 0
  }
  return pcp.discount
}
